import { HttpClient } from './http-client';

export class MailerLiteService extends HttpClient {
  subscribe(email: string): any {
    return this.post<string>(`/api/mailer-lite/subscribe/${email}`);
  }
}
